import { get, put, post } from "./api_helper"

export const getSheet = id =>
  get(`admin/master/order-sheet/creation/${id}/handwriting`)

export const addSheet = datas =>
  post(
    `admin/master/order-sheet/creation/${datas.id}/handwriting`,
    datas.formData
  )
